"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/services/Cognito/authStore";

const ProtectedPageWrapper = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const authStatus = useAuthStore((ctx) => ctx.status);

  useEffect(() => {
    if (authStatus === "authenticated" || authStatus === "unauthenticated")
      router.refresh();
  }, [router, authStatus]);

  return children;
};

export default ProtectedPageWrapper;
